import * as React from "react";
import { ButtonToolbar } from "rsuite";
import styled from "styled-components";
import { DesignSystem as DS, Config } from "configs/index";

const StyledLink = styled.a`
	background-color: ${DS.colors.primary};
	color: #fff;
	padding: "8px 12px";
	display: inline-block;
	line-height: 1.4;

	&:hover,
	&:active,
	&:focus,
	&:visited,
	&:focus-visible,
	&:active:focus {
		background: ${DS.colors.primary}!important;
		color: #fff;
	}
`;

export const SuccessPass: React.FunctionComponent<any> = () => {
	return (
		<>
			<h5 className="d-flex align-items-center mt-4">
				<strong style={{ color: DS.colors.primary }}>
					Tu contraseña se ha modificado con éxito
				</strong>
			</h5>
			<p className="mt-2">
				Por favor vuelve a autenticarte con los nuevos datos de acceso
			</p>
			<ButtonToolbar className="d-flex justify-content-end mt-2">
				<StyledLink className="rs-btn mr-2" href={Config.BASE_URL}>
					<span className="btn-label">Login</span>
				</StyledLink>
			</ButtonToolbar>
		</>
	);
};
